<template>
  <b-sidebar
    id="sidebar-create-organization"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ organization.id ? $t('Update Organization') : $t('Create Organization') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <b-form-group
          :label="$t('name')"
          label-for="name"
        >
          <b-form-input-lang :value="organization.name" />
        </b-form-group>

        <b-form-group
          :label="$t('STIR')"
          label-for="STIR"
        >
          <b-form-input
            id="STIR"
            v-model="organization.inn"
            trim
          />
        </b-form-group>
        <b-form-group
          :label="$t('Short Name')"
          label-for="short_name"
        >
          <b-form-input-lang :value="organization.short_name" />
        </b-form-group>

        <!-- Address -->
        <b-form-group
          :label="$t('Address')"
          label-for="address"
        >
          <b-form-input
            id="address"
            v-model="organization.address"
            trim
          />
        </b-form-group>

        <!-- Tel -->
        <b-form-group
          :label="$t('Mobile phone')"
          label-for="tel"
        >
          <b-form-input
            id="tel"
            v-model="organization.tel"
            trim
          />
        </b-form-group>
        <!-- Type Org Id -->
        <b-form-group
          :label="$t('Type Org')"
          label-for="type_org_id"
        >
          <v-select
            id="type_org_id"
            v-model="organization.type_org_id"
            :reduce="(option) => option.id"
            :options="orgTypes"
            :get-option-label="(option) => option.name[$i18n.locale]"
          />
        </b-form-group>

        <b-form-group
          :label="$t('Parent organization')"
          label-for="parent_id"
        >
          <v-select
            id="org_parent_id"
            v-model="organization.parent_id"
            :reduce="(option) => option.id"
            :options="ministries"
            :get-option-label="(option) => option.name ? $langName(option.name): null"
          />
        </b-form-group>

        <b-form-group
          :label="$t('Region')"
          label-for="region"
        >
          <v-select
            id="region"
            v-model="organization.region"
            :reduce="(option) => option.id"
            :options="regions"
            :get-option-label="(option) => $langName(option.name)"
          />
        </b-form-group>

        <b-form-group
          :label="$t('Status')"
          label-for="status"
        >
          <v-select
            id="status"
            v-model="organization.status"
            :reduce="(option) => option.id"
            :options="organizationStatuses"
            :get-option-label="(option) => $langName(option.name)"
          />
        </b-form-group>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ organization.id ? $t('Update Organization') : $t('Create Organization') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import BFormInputLang from '@/views/components/b-form-input-lang.vue'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormInputLang,
    vSelect,
  },
  directives: {
    Ripple,
  },
  computed: {
    ministries() {
      return this.$store.state.organization.ministries
    },
    organization: {
      get() {
        return this.$store.state.organization.organization
      },
      set(data) {
        this.$store.commit('organization/UPDATE', data)
      },
    },
    regions: {
      get() {
        return this.$store.state.region.regions
      },
    },
    orgTypes: {
      get() {
        return this.$store.state.staticModule.orgTypes
      },
    },
    organizationStatuses() {
      return this.$store.state.staticModule.organizationStatuses
    },
  },
  methods: {
    clear(hide) {
      this.$store.commit('organization/FRESH')
      hide()
    },
    submit(hide) {
      this.$createSwal(this, this.organization, `organization/${this.organization.id ? 'update' : 'create'}`, () => {
        this.$emit('refetchData')
        this.$store.commit('organization/FRESH')
      })
      hide()
    },
  },
}
</script>
